import { FC } from 'react';
import { Image, ThemeImageProps } from '@base/lib/ThemeImage';
import site from 'pro/config/site';
import { RouteEnum } from 'pro/config/routers';
import { assets } from 'pro/config/assets';

export type ISiteLogoProps = Omit<ThemeImageProps, 'src' | 'href' | 'width'> & {
    type?: 'default' | 'darkIcon' | 'darkText' | 'light' | 'lightIcon' | 'lightText';
    href?: false | string;
    size?: number;
    className?: string;
}

function getOriginSize(type) {
    if (type.endsWith('Icon')) {
        return {
            width: 68,
            height: 40,
        }
    } else if (type.endsWith('Text')) {
        return {
            width: 343,
            height: 40,
        }
    }
    return {
        width: 165,
        height: 30,
    }
}

export const SiteLogo: FC<ISiteLogoProps> = (props) => {
    const {
        type = 'default',
        href = RouteEnum.HOME,
        className,
        fixed = true,
        size,
        ...rest
    } = props

    const originSize = getOriginSize(type);
    const width = size || originSize.width;
    const height = width === originSize.width ? originSize.height : Math.round((width * originSize.height) / originSize.width)

    return (
        <Image
            className={className}
            href={href === false ? void 0 : href}
            src={assets.logo[type] || assets.logo.default}
            width={width}
            height={height}
            alt={site.brand}
            fixed={fixed}
            background={false}
            {...rest}
        />
    )
};

export default SiteLogo;